export const perGuestBudgetsLondon = [
  `£50-£100`,
  `£101-£150`,
  `£151-£200`,
  `£201-£300`,
  `£301+`
];
